// Styles for CreateAccountConfirmIdentity go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCreateAccountConfirmIdentity = styled.div`
  .confirm-identity {
    gap: ${toRem(32)};
    &__send-code {
      width: 100%;
      @media ${baseVariables.mediaQuery.md} {
        width: max-content;
      }
      @media ${baseVariables.mediaQuery.lg} {
        min-width: ${toRem(214)};
      }
    }
    &__horizantal-line {
      height: ${toRem(1)};
      background: ${baseVariables.color['neutral40']};
    }
    &__radio_btn:before {
      height: ${toRem(18)};
      width: ${toRem(18)};
      top: ${toRem(1)};
      left: ${toRem(1)};
    }
  }
`;
